import React, { Component } from 'react'
import faqs from './faqs'
import { Link } from 'react-router-dom'
import Background from '../../components/Background/Background'
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount/ScrollToTopOnMount'
import Markdown from '../../components/Markdown/Markdown'
import Title from '../../components/Title/Title'
import Button from '../../components/Button/Button'

class Faq extends Component {
  render () {
    return (
      <Background color="#FFB297">
        <ScrollToTopOnMount />
        <section className="bg-peach-color ph3 ph4-ns pv4 flex flex-column items-center">
          <div className="mw7 center tl">
            <Link
              className="db mv3 no-underline primary-font-book f3 secondary-color"
              to="/steg/konklusjon"
            >
              ← Tilbake
            </Link>
            <Title secondary>Ofte stilte spørsmål</Title>
            <Markdown source={faqs} secondary />
          </div>
          <Button pill>
            <Link className="db tc w-100 no-underline" to="/">
              Sjekk om barnet er i risikosonen
            </Link>
          </Button>
          <p>DiBianco JM et al Avicenna J Med 2014;4(4):77</p>
        </section>
      </Background>
    )
  }
}

export default Faq



// WEBPACK FOOTER //
// ./src/containers/Faq/Faq.js